import addNewTeamToExistingLeague from "./addNewTeamToExistingLeague.ts";
import avgAge from "./avgAge.ts";
import checkRosterSizes from "./checkRosterSizes.ts";
import deleteUnreadMessages from "./deleteUnreadMessages.ts";
import disable from "./disable.ts";
import ensureValidDivsConfs from "./ensureValidDivsConfs.ts";
import evaluatePointsFormula from "./evaluatePointsFormula.ts";
import genSeasonRow from "./genSeasonRow.ts";
import genStatsRow from "./genStatsRow.ts";
import generate from "./generate.ts";
import getContracts from "./getContracts.ts";
import getPayroll from "./getPayroll.ts";
import getPayrolls from "./getPayrolls.ts";
import ovr from "./ovr.ts";
import processStats from "./processStats.ts";
import ptsMax from "./ptsMax.ts";
import ptsPct from "./ptsPct.ts";
import resetTicketPrice from "./resetTicketPrice.ts";
import rosterAutoSort from "./rosterAutoSort.ts";
import switchTo from "./switchTo.ts";
import stats from "./stats.ts";
import updateClinchedPlayoffs from "./updateClinchedPlayoffs.ts";
import updateStrategies from "./updateStrategies.ts";
import valueChange from "./valueChange.ts";

export default {
	addNewTeamToExistingLeague,
	avgAge,
	checkRosterSizes,
	deleteUnreadMessages,
	disable,
	ensureValidDivsConfs,
	evaluatePointsFormula,
	genSeasonRow,
	genStatsRow,
	generate,
	getContracts,
	getPayroll,
	getPayrolls,
	ovr,
	processStats,
	ptsMax,
	ptsPct,
	resetTicketPrice,
	rosterAutoSort,
	switchTo,
	stats,
	updateClinchedPlayoffs,
	updateStrategies,
	valueChange,
};
